/**
 * @generated SignedSource<<a7af79061cef0332b8d383a78eb4a04d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActive_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallment_query" | "PaymentActivePixCreditCard_query">;
  readonly " $fragmentType": "PaymentActive_query";
};
export type PaymentActive_query$key = {
  readonly " $data"?: PaymentActive_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActive_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActive_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActivePixCreditCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveInstallment_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7b7b9511c566b9fa427b6148b453201a";

export default node;
